module.exports = __webpack_public_path__ + "img/pos2-bg.741b8707.jpg";